module.exports = __webpack_public_path__ + "static/media/avatarNew2.306df07c.jpg";